import React from 'react';

const ProfilePaddleIcon = ({ color = '#000000' }) => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18">
      <g fill="none" fillRule="evenodd" stroke="#960000">
        <path
          strokeLinecap="round"
          strokeWidth="1.4"
          stroke={color}
          d="M17.24 1c.42 0 .76.338.76.756v8.621c0 .418-.34.756-.76.756h-6.679V17H8.438l-.001-5.867H1.761A.758.758 0 011 10.377V1.756C1 1.338 1.34 1 1.76 1h15.48z"
        ></path>
        <path
          stroke={color}
          fillRule="nonzero"
          strokeWidth="0.2"
          d="M9.804 5.265h-.608c-.346 0-.628-.233-.628-.52 0-.287.282-.52.628-.52h1.216c.157 0 .284-.105.284-.235s-.127-.235-.284-.235h-.628v-.52c0-.13-.127-.235-.284-.235-.157 0-.284.105-.284.235v.52h-.02c-.66 0-1.196.444-1.196.99s.537.99 1.196.99h.608c.346 0 .628.233.628.52 0 .287-.282.52-.628.52H8.588c-.157 0-.284.105-.284.235s.127.235.284.235h.628v.52c0 .13.127.235.284.235.157 0 .284-.105.284-.235v-.52h.02c.66 0 1.196-.444 1.196-.99s-.537-.99-1.196-.99z"
        ></path>
      </g>
    </svg>
  );
};

export default ProfilePaddleIcon;
